<template>
  <div>
    <v-card class="mb-2 light-green lighten-4">
      <v-card-text>
        <div class="d-flex">
          <div style="width: 238px;">
            <div>{{ rs.ServiceType }}</div>
          </div>
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="editRecurringServiceClick"
                >
                  <v-icon :color="feature.recurringServices.color">
                    {{ feature.recurringServices.icon }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit Recurring Service</span>
            </v-tooltip>
          </div>
        </div>
        <div class="d-flex">
          <div v-if="rs.FrequencyDescription">
            {{ rs.FrequencyDescription }}
          </div>
          <v-spacer />
          <div>{{ rs.SeasonDescription }}</div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { feature } from '@/use/Constants'
import { toLocaleDateString } from '@/use/DateFormatter'
export default {
  name: 'RecurringServiceSummaryCard',
  props: {
    rs: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    const editRecurringServiceClick = () => {
      context.emit('editRecurringService', props.rs.RecurringServiceId)
    }

    return { feature, editRecurringServiceClick, toLocaleDateString }
  }
}
</script>

<style lang="scss" scoped></style>
